import React from 'react'
import { connect } from 'react-redux'

import { translate } from 'parking-react-common'

import EmailPasswordResetForm from '../components/EmailPasswordResetForm'

const EmailLoginContainer = () => (
    <EmailPasswordResetForm />
)

export default translate()(connect()(EmailLoginContainer))
